import React, { useEffect, useRef, useState } from 'react';

import { GapWord } from 'shared/types';

interface Props {
  gapWord: GapWord;
  isInputDisabled: boolean;
  changeFormikGapWords: (currentGapWord: GapWord) => void;
}

export const StudentGapWord = ({ gapWord, changeFormikGapWords, isInputDisabled }: Props) => {
  const [width, setWidth] = useState(gapWord.answer.length);
  const spanRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (spanRef !== null && spanRef.current) {
      setWidth(spanRef.current.offsetWidth + 25);
    }
  }, [gapWord.answer]);

  return (
    <div>
      <span
        ref={spanRef}
        className="absolute -z-50 inline-block !border-0 px-3 opacity-0"
        style={{ whiteSpace: 'pre' }}
      >
        {gapWord.answer}
      </span>

      <input
        type="text"
        style={{ width }}
        value={gapWord.answer}
        onChange={event => changeFormikGapWords({ ...gapWord, answer: event.target.value })}
        className="min-w-4 !border-x-0 !border-b-2 !border-t-0 border-black bg-transparent px-3 text-center text-lg font-medium leading-[25px] outline-none lg:text-xl"
        maxLength={21}
        disabled={isInputDisabled}
      />
    </div>
  );
};
